export type QrPayload = {
  o: string;
  a: string;
};

export const decodeQrPayload = (raw: string): QrPayload => {
  const normalised = raw.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalised + '='.repeat((4 - (normalised.length % 4)) % 4);
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
  const json = new TextDecoder('utf-8').decode(bytes);
  const parsed = JSON.parse(json);
  if (typeof parsed?.o !== 'string' || typeof parsed?.a !== 'string') {
    throw new Error('malformed qr payload');
  }
  return { o: parsed.o, a: parsed.a };
};
